import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.css',
})
export class EditProfileComponent {
  activeTab = 'home';
  isDarkMode = false;
  store: any;

  constructor(
    private router: Router,
    private storeData: Store<any>,
    private analitycs: AnalitycsService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }
  goBack() {
    this.analitycs.logEvent('ir_a_perfil', {
      pantalla: 'edit-profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/profile']);
  }
}
